var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmsConfig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 63,
    viewBox: "0 0 67 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0845 29.8437C36.1298 29.8437 38.5986 27.375 38.5986 24.3296C38.5986 21.2842 36.1298 18.8154 33.0845 18.8154C30.0391 18.8154 27.5703 21.2842 27.5703 24.3296C27.5703 27.375 30.0391 29.8437 33.0845 29.8437Z",
    fill: "#616161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6706 30.273V7.90619C58.6706 6.85937 57.8144 6.00854 56.7622 6.00854H9.4073C8.36155 6.00854 7.51074 6.85937 7.51074 7.90619V30.2837L32.9522 43.466C50.2242 34.7235 50.3533 34.57 58.6706 30.273ZM30.8242 35.3029C29.4127 35.0161 28.1002 34.4537 26.9313 33.6927L24.9463 34.9609L22.4649 32.4796L23.7331 30.4946C22.9722 29.3255 22.4097 28.0132 22.123 26.6015L19.818 26.0943V22.5872L22.123 22.0798C22.4097 20.6572 22.9722 19.3448 23.7331 18.1759L22.4649 16.1909L24.9463 13.7095L26.9313 14.9887C28.1002 14.2168 29.4127 13.6543 30.8242 13.3676L31.3316 11.0625H34.8386L35.3459 13.3676C36.7686 13.6543 38.0809 14.2168 39.2499 14.9887L41.235 13.7095L43.7163 16.1909L42.437 18.1869C43.2091 19.3448 43.7605 20.6683 44.0581 22.0798L46.3632 22.5872V26.0943L44.0581 26.6015C43.7605 28.0132 43.2091 29.3255 42.437 30.4946L43.7163 32.4796L41.235 34.9609L39.2499 33.6927C38.0809 34.4537 36.7686 35.0161 35.3459 35.3029L34.8386 37.6078H31.3316L30.8242 35.3029Z",
    fill: "#616161"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.877 23.1648V29.1317L65.2922 26.8463L60.877 23.1648Z",
    fill: "#616161"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0848 0L28.5225 3.80282H37.648L33.0848 0Z",
    fill: "#616161"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2802 31.9229L45.0762 39.7991L66.1691 60.9326V28.875L60.2802 31.9229Z",
    fill: "#616161"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0219 40.8639L33.5923 45.7523C33.2196 45.9475 32.5489 45.8754 32.3139 45.7523L22.7266 40.7799C20.5848 42.9732 30.4856 32.8342 1.7793 62.2312H64.3488C60.0408 57.915 75.4162 73.3197 43.0219 40.8639Z",
    fill: "#616161"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7631 39.634C20.247 39.3665 19.0631 38.7531 0 28.876V60.8963C11 49.6311 -4.8712 65.8748 20.7631 39.634Z",
    fill: "#616161"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30496 23.1533L0.876953 26.8468L5.30496 29.1413V23.1533Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsConfig);
export default __webpack_public_path__ + "static/media/SmsConfig.b2ce0580ef4b7d5b5b94737f023d6604.svg";
export { ForwardRef as ReactComponent };